import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';
import { Dropdown } from './Dropdown';
import { StickInParent } from './StickInParent';
import * as constants from '../../model/const';

import { ItemDescriptor } from './ItemDescriptor';
import { fmtPrice, fmtPercent, fmtDate, fmtTime } from '../../model/formatters';
import translateBase from '../../translate';
let translate = translateBase.bindComponent('bwReceipt');

function getServicesCount(aggServices) {
    return aggServices.joinedListing.filter(o => o.inTransaction.id && o.available.typeId === constants.SERVICE_TYPE.WAHLBAR).length +
        aggServices.joinedListing.filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.OBLIGATORISCH).length +
        aggServices.joinedListing.filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.BEDINGT).length +
        aggServices.joinedListing.filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.BEIRESERVATION).length
}


@inject(stores => ({
    rentalTransaction: stores.app.rentalTransaction,
    aggServices: stores.app.aggServices,
    aggAccessories: stores.app.aggAccessories,
    businessUnit: stores.app.businessUnit,
}))
@observer
export class BWReceipt extends React.Component {
    render() {
        const { rentalTransaction, aggServices, aggAccessories, businessUnit } = this.props;
        const currency = businessUnit.currencyName; //'CHF';
        const getDiscountTitle = () => {
            return rentalTransaction.totalDiscount > 0 ?
                translate("totalSurcharge", "Total Surcharge") :
                translate("totalDiscount", "Total Rabatt")
        }

        const getDiscountDetails = () => {
            let discounts = [];
            let hasFeeDiscount = rentalTransaction.discountRate != 0;
            let hasSvcDiscount = rentalTransaction.normServiceDiscount != 0;
            let hasConsDiscount = rentalTransaction.consumableDiscountPrice != 0;
            if (hasFeeDiscount) {
                discounts.push(rentalTransaction.rentalFeeDiscountName);
            }
            if (hasSvcDiscount) {
                discounts.push(rentalTransaction.serviceDiscountName);
            }
            if (hasConsDiscount) {
                discounts.push(rentalTransaction.consumablesDiscountName);
            }
            let uniqueDiscounts = [...new Set(discounts)];
            return uniqueDiscounts.join(' / ');
        }
        return (
            <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <StickInParent>{({ ref: sipRef }) => <Observer>{() =>
                <section className="receipt-container booking-view sticky-container" ref={sipRef} id="sticky-container">
                    <div className="receipt-wrapper">
                        <div className="wrapper">
                            <div className="row">
                                <div className="column-12">
                                    <div className="product-name biggest">
                                        {rentalTransaction.name}
                                    </div>
                                    {rentalTransaction.rentingStartDate &&
                                        rentalTransaction.rentingStartDate &&
                                        moment(rentalTransaction.rentingStartDate).isValid() &&
                                        moment(rentalTransaction.rentingStartDate).isValid() &&
                                        <div className="booking-dates">
                                            <div className="from">
                                                <div className="label">{translate("bookedFrom", "Buchung von")}</div>
                                                <div className="value">
                                                    {fmtDate(rentalTransaction.rentingStartDate)} &ndash; {fmtTime(rentalTransaction.rentingStartDate)}
                                                </div>
                                            </div>
                                            <div className="till">
                                                <div className="label">{translate("bookedTo", "bis")}</div>
                                                <div className="value">
                                                    {fmtDate(rentalTransaction.rentingEndDate)} &ndash; {fmtTime(rentalTransaction.rentingEndDate)}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="product-total">
                                        <div className="label">{translate("barMietbetrag", "Mietbetrag")}</div>
                                        <div className="amount">{currency} {fmtPrice(rentalTransaction.totalDiscountedPrice)}</div>
                                        <div className="price-detail-trigger">
                                            <a onClick={onOpen}><i className={"fa" + (isOpen ? " fa-times" : " fa-shopping-cart")} aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {<div className={"price-detail-wrapper" + (isOpen ? ' active' : '')} ref={ref}>
                        <div className="wrapper">
                            {rentalTransaction.mainObjectOffers.length > 0 &&
                                <div className="row">
                                    <div className="column-12">
                                        <div className="offers-entry">
                                            <div className="title">{translate("recOffer", "Angebot")}</div>
                                            {rentalTransaction.mainObjectOffers.map(offer =>
                                                <div className="list-entry">
                                                    <div className="input">
                                                        <span className="number">{offer.quantity}</span>
                                                        {offer.name}
                                                        {offer.prolongationOfferQuantity > 0 &&
                                                            <div className="prolongation">
                                                                <span className="number">{offer.prolongationOfferQuantity}</span>
                                                                {offer.prolongationName}
                                                            </div>}
                                                    </div>
                                                    <div className="value">{currency} {fmtPrice(offer.price)}</div>
                                                    <div className="amount"><input /></div>
                                                    <div className="price">{currency} {fmtPrice(offer.price)}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {getServicesCount(aggServices) > 0 &&
                                <div className="row">
                                    <div className="column-12">
                                        <div className="services-entry">
                                            <div className="title">{translate("recServices", "Dienstleistungen")}</div>
                                            {aggServices.joinedListing
                                                .filter(o => o.inTransaction.id && o.available.typeId === constants.SERVICE_TYPE.WAHLBAR).map(item =>
                                                    <div className={"list-entry" + (item.inTransaction.price < 0 ? " discount" : "")}>
                                                        <div className="input">
                                                            <ItemDescriptor description={item.available.description}>{item.available.name}</ItemDescriptor>
                                                        </div>
                                                        <div className="value">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                        <div className="amount"><input /></div>
                                                        <div className="price">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                    </div>
                                                )}
                                            {aggServices.joinedListing
                                                .filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.OBLIGATORISCH).map(item =>
                                                    <div className={"list-entry" + (item.inTransaction.price < 0 ? " discount" : "")}>
                                                        <div className="input">
                                                            <ItemDescriptor description={item.available.description}>{item.available.name}</ItemDescriptor>
                                                            {item.inTransaction.price < 0 && <span>{translate("recDiscount", "Rabatt")}</span>}</div>
                                                        <div className="value">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                        <div className="amount"><input /></div>
                                                        <div className="price">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                    </div>
                                                )}
                                            {aggServices.joinedListing
                                                .filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.BEDINGT).map(item =>
                                                    <div className={"list-entry" + (item.available.fixedPrice < 0 ? " discount" : "")}>
                                                        <div className="input">
                                                            <ItemDescriptor description={item.available.description}>{item.available.name}</ItemDescriptor>
                                                        </div>
                                                        <div className="value">
                                                            {currency} {fmtPrice(item.available.fixedPrice)}
                                                        </div>
                                                        <div className="amount"><input /></div>
                                                        <div className="price">
                                                            {currency} {fmtPrice(item.available.fixedPrice)}
                                                        </div>
                                                    </div>
                                                )}
                                            {aggServices.joinedListing
                                                .filter(o => o.inTransaction && o.available.typeId === constants.SERVICE_TYPE.BEIRESERVATION).map(item =>
                                                    <div className={"list-entry" + (item.available.fixedPrice < 0 ? " discount" : "")}>
                                                        <div className="input">
                                                            <ItemDescriptor description={item.available.description}>{item.available.name}</ItemDescriptor>
                                                        </div>
                                                        <div className="value">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                        <div className="amount"><input /></div>
                                                        <div className="price">
                                                            {currency} {fmtPrice(item.inTransaction.price)}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {aggAccessories.joinedListing.filter(o => o.inTransaction).length > 0 &&
                                <div className="row">
                                    <div className="column-12">
                                        <div className="accessories-entry">
                                            <div className="title">{translate("recAccessories", "Zubehör")}</div>
                                            {aggAccessories.joinedListing.filter(o => o.inTransaction).map(item =>
                                                <div className={"list-entry" + (item.sumTotalPrice < 0 ? " discount numeral" : "")}>
                                                    <div className="input">
                                                        <span className="number">{item.quantity}</span>
                                                        <ItemDescriptor description={item.description}>{item.name}</ItemDescriptor>
                                                    </div>
                                                    <div className="value">{currency} {fmtPrice(item.sumTotalPrice)}</div>
                                                    <div className="amount"><input /></div>
                                                    <div className="price">{currency} {fmtPrice(item.sumTotalPrice)}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {rentalTransaction.deposit > 0 &&
                                <div className="row">
                                    <div className="column-12">
                                        <div className="accessories-entry">
                                            <div className="title">{translate("recDeposit", "Kaution")}</div>
                                            <div className={"list-entry"}>
                                                <div className="input">
                                                    <ItemDescriptor>{translate("recDeposit", "Kaution")}</ItemDescriptor>
                                                </div>
                                                <div className="value">{currency} {fmtPrice(rentalTransaction.deposit)}</div>
                                                <div className="amount"><input /></div>
                                                <div className="price">{currency} {fmtPrice(rentalTransaction.deposit)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {rentalTransaction.totalDiscount != 0 &&
                                <div className="row">
                                    <div className="column-12">
                                        <div className="discount-entry">
                                            <div className="title">{getDiscountTitle()}</div>
                                            <div className={"list-entry" + (rentalTransaction.totalDiscount < 0 ? " discount" : "")}>
                                                <div className="input">
                                                    {getDiscountDetails()}
                                                    {rentalTransaction.totalDiscount < 0 && <span>{translate("discount", "Rabatt")}</span>}
                                                </div>
                                                <div className="price">{currency} {fmtPrice(rentalTransaction.totalDiscount)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="column-12">
                                    <p className="vat-infoText">{translate('vatIncluded', 'All prices are including VAT')}</p>
                                </div>
                            </div>
                        </div>
                    </div>}
                </section>
            }</Observer>}</StickInParent>}</Dropdown>
        )
    }
}


// WEBPACK FOOTER //
// ./src/visual/component/BWReceipt.js